import { ecLean, itemField, type Row } from '../ability/context.js';
import { browserDependencies } from '../port/browser-dependencies.js';
import { legendaryCreatureApsPoolTotal } from '../port/k4-dispatch/sync_legendary_creature_aps_pool_for_turn.js';
import { countPlayerCharactersInEncounterForLegendaryPool } from '../port/k4-dispatch/count_player_characters_in_encounter_for_legendary_pool.js';
import { ftEncounterCreatureIsEligibleForLegendaryTurn } from '../port/k4-dispatch/legendary_turn_helpers.js';
import type { E } from '../port/k4-dispatch/support-b2.js';
import type { ReadEnv } from '../port/k4-dispatch/shared.js';

interface Readers { roster: () => Row[]; value: (row: Row, key: string) => unknown }
function environment(read: Readers): E {
  const deps = {
    item_field: (value: unknown, key: unknown) => key === 'item_type'
      ? ecLean(value as Row, 'item_type') ?? itemField(value as Row, 'item_type') : itemField(value as Row, String(key)),
    encounter_creature_field: (value: unknown, key: unknown) => ecLean({ encounter_creatures: value }, String(key)),
    layer_value: (value: unknown, key: unknown) => read.value(value as Row, String(key)),
    ft_encounter_context: () => ({ encounter_creatures_arr: read.roster() }),
    count_player_characters_in_encounter_for_legendary_pool: (value: unknown) =>
      countPlayerCharactersInEncounterForLegendaryPool(value as Row, browserDependencies(deps) as unknown as ReadEnv),
  };
  return browserDependencies(deps) as unknown as E;
}

export function legendaryPoolTotal(row: Row, read: Readers): number | null {
  return legendaryCreatureApsPoolTotal(row, environment(read));
}
export function legendaryTurnEligible(row: Row, read: Readers): boolean {
  return ftEncounterCreatureIsEligibleForLegendaryTurn(row, environment(read));
}
